<template>
	<div class="download how-to-getcode">
		<div class="white-wrap">
			<div class="how-close" @click="closeAboutAlert"></div>
			<div class="title"></div>
			<div class="item-wrap">
				<div class="item">
					<div class="item-icon"></div>
					<div class="item-text-wrap">
						<div class="item-text1">相册备份</div>
						<div class="item-text2">精彩瞬间 一键导出</div>
					</div>
					<!-- <div class="open-btn">打开</div> -->
					<div class="line"></div>
					<div class="item-text3">
						一键导出手机相册到电脑/NAS，保存精彩美好瞬间
					</div>
					<div class="item-text4 item-text41">
						无需数据线，随时随地可备份
					</div>
					<div class="item-text4">可跨网传输，全速传输不限速</div>
					<div class="item-text4">原图不压缩，高清大图安心传</div>
				</div>
				<div class="item item2">
					<div class="item-icon item-icon2"></div>
					<div class="item-text-wrap">
						<div class="item-text1">小宝驿站</div>
						<div class="item-text2">
							开一间小宝驿站，乐享积分收益。
						</div>
					</div>
					<!-- <div class="open-btn">打开</div> -->
					<div class="line"></div>
					<!-- <div class="item-text3">
						加入小宝驿站，共享闲置带宽，躺赚积分收益
					</div> -->
					<div class="item-text3">驿站租用闲置空间，赚取积分收益</div>
					<div class="item-text4">不影响网络冲浪、购物等体验</div>
					<div class="item-text4">积分可兑换电话卡或各类VIP会员</div>
				</div>
				<div class="item item2 item3">
					<div class="item-icon item-icon3"></div>
					<div class="item-text-wrap">
						<div class="item-text1">小宝商城</div>
						<div class="item-text2">各大影视会员，应有尽有</div>
					</div>
					<!-- <div class="open-btn">打开</div> -->
					<div class="line"></div>
					<div class="item-text3">积分海量甄选会员权益，持续上新</div>
					<div class="item-text4 item-text41">影视会员</div>
					<div class="item-text4">音乐会员</div>
					<div class="item-text4">云盘会员</div>
					<div class="item-text4">话费充值</div>
				</div>
				<div class="item item2 item4">
					<div class="item-icon item-icon4"></div>
					<div class="item-text-wrap">
						<div class="item-text1">宽带提速</div>
						<div class="item-text2">
							电信联通官方授权，一键宽带提速
						</div>
					</div>
					<!-- <div class="open-btn">打开</div> -->
					<div class="line"></div>
					<div class="item-text3">一键提速，最高支持提速至700M</div>
					<div class="item-text4 item-text41">支持全国28省份</div>
					<div class="item-text4">优质售后服务 无效退款</div>
					<div class="item-text4">电信联通权威技术支持</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Download",
	props: ["isShowAbout"],
	methods: {
		closeAboutAlert: function () {
			let _that = this;
			_that.$emit("closeAboutAlert");
		},
	},
};
</script>

<style lang="less" scoped>
.how-to-getcode {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 9;
	.white-wrap {
		position: absolute;
		padding-top: 1px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 700px;
		height: 450px;
		background: linear-gradient(180deg, #c6e2ff -74%, #fafcfe 76%);
		border-radius: 8px;
		box-sizing: border-box;

		.how-close {
			position: absolute;
			top: 16px;
			right: 16px;
			width: 24px;
			height: 24px;
			background-image: url("../../assets/remote/close1.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			cursor: pointer;
		}
		.title {
			margin-top: 31px;
			margin-left: 35px;
			width: 120px;
			height: 34px;
			background-image: url("../../assets/remote/about34.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.item-wrap {
			margin-top: 24px;
			padding-bottom: 10px;
			width: 100%;
			height: 345px;
			overflow: auto;
			box-sizing: border-box;
			.item {
				position: relative;
				padding-top: 1px;
				margin: 0 auto;
				width: 530px;
				height: 195px;
				background: #ffffff;
				box-shadow: 0px 4px 12px rgba(159, 168, 186, 0.24);
				border-radius: 8px;
				box-sizing: border-box;
				.item-icon {
					display: inline-block;
					vertical-align: top;
					margin-top: 16px;
					margin-left: 25px;
					width: 48px;
					height: 48px;
					background-image: url("../../assets/remote/about35.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
				.item-icon2 {
					background-image: url("../../assets/remote/about36.png");
				}
				.item-icon3 {
					background-image: url("../../assets/remote/about37.png");
				}
				.item-icon4 {
					background-image: url("../../assets/tool/kdts-icon.png");
				}
				.item-text-wrap {
					display: inline-block;
					margin-left: 8px;
					margin-top: 21px;
					vertical-align: top;
					.item-text1 {
						font-weight: 600;
						font-size: 16px;
						line-height: 22px;
						color: #5c5c5c;
					}
					.item-text2 {
						margin-top: 1px;
						color: #999999;
						font-size: 12px;
						line-height: 17px;
					}
				}
				.open-btn {
					position: absolute;
					top: 25px;
					right: 32px;
					width: 54px;
					height: 22px;
					line-height: 22px;
					text-align: center;
					background: linear-gradient(
						276deg,
						#386abd -10%,
						#143977 82%
					);
					border-radius: 36px;
					font-weight: 600;
					font-size: 12px;
					color: #ffffff;
					cursor: pointer;
				}
				.line {
					margin: 0 auto;
					margin-top: 9px;
					width: 467px;
					height: 1px;
					background-color: rgba(0, 0, 0, 0.05);
				}
				.item-text3 {
					margin-top: 13px;
					margin-left: 30px;
					font-weight: 600;
					font-size: 12px;
					line-height: 17px;
					color: rgba(0, 0, 0, 0.8);
				}
				.item-text4 {
					position: relative;
					margin-left: 40px;
					margin-top: 7px;
					font-size: 12px;
					line-height: 17px;
					color: rgba(0, 0, 0, 0.7);
				}
				.item-text4::before {
					position: absolute;
					left: -10px;
					top: 5px;
					content: "";
					width: 5px;
					height: 5px;
					background-color: #2c5aa5;
					border-radius: 50%;
				}
				.item-text41 {
					margin-top: 9px;
				}
			}
			.item2 {
				height: 172px;
				margin-top: 15px;
			}
			.item3 {
				height: 220px;
			}
			.item4 {
				height: 204px;
			}
		}
	}
}
</style>